export default __webpack_public_path__ + "static/media/358.4c44b6c9.jpg";